import React, { useEffect, useState } from 'react'
import ActionButton from '../../../../common/input-fields/ActionButton'
import { FieldVariants } from '../../../../common/input-fields/utils/appInputenum'
import EditIcon from '@mui/icons-material/Edit';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';
import { Box, Divider, Grid, LinearProgress, Typography } from '@mui/material';
import RichTextInput from '../../../../common/rich-text-input/RichTextInput';
import PdfTemplateDownload from '../../../../common/export-files/PdfTemplateDownload';
import UDataGrid from '../../../../common/data-grids/UDataGrid';
import StorageIcon from '@mui/icons-material/Storage';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import { updateAnalysisDetails } from '../../../../services/services';
import { ToastContainer, toast } from 'react-toastify';
import { analysisToastMessages } from '../../../../utils/toastMessages';
import secureLocalStorage from 'react-secure-storage';

const InvestmentConcept = (props) => {

  //#region props
  const { aiGeneratedDetails,fetchReportDetails,analysisDetails }  = props;

  //#region initialData
  const initialData = {
    companyOverview: `<p>This is the initial content for companyOverview Concept.</p>`,
    dealBackground: "This is the initial content for dealBackground Concept.",
    useOfFunds: "This is the initial content for useOfFunds Concept.",
    RevenueModel: "This is the initial content for Revenue Model Concept.",
    financialForecastSummary: "This is the initial content for financialForecastSummary Concept.",
    investmentSummary: "This is the initial content for invetsmentSummary Concept.",
    balanceSheetSnapshot: "This is the initial content for balanceSheetSnapshot Concept.",
    marketCompetition: "This is the initial content for marketCompetition Concept.",
    cashFlowSnapShot: "This is the initial content for cashFlowSnapShot Concept.",
    plSnapshot: "This is the initial content for plSnapshot Concept.",
    Transaction: "This is the initial content for Transaction Concept.",
    overallTransaction: "This is the initial content for overallTransaction Concept.",
    overallTransactionColumns: [],
    transactionColumns: []
  }

  //#region variables
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const [companyDetails, setCompanyDetails] = useState();
  const [loading, setLoading] = useState(false);

  const [tiles, setTiles] = useState([
   /*  { name: "Risk Analyzed", value: "NA", icon: <ShowChartIcon className='tile-icon-size' /> }, */
    { name: "No Data Available", value: analysisDetails?.extAPIResponse["total_number_N/A"], icon: <StorageIcon className='tile-icon-size' /> },
    /* { name: "Readability Percentage", value: "NA", icon: <ImportContactsIcon className='tile-icon-size' /> }, */
  ])

  const leftCompanyFields = [
    { name: "dealBackground", label: "Deal Background", },
    { name: "companyOverview", label: "Company Overview", },
    { name: "marketCompetition", label: "Market Competition", },
    { name: "investmentSummary", label: "Investment Summary", },
  ];

  const rightCompanyFields = [
    { name: "revenueModel", label: "Revenue Model", },
    { name: "customers", label: "Customers"}, 
    /* { name: "transaction", label: "Transaction", }, */
  ]

  //#region functions
  const formatSection = (sectionObj) => {
    if (!sectionObj) return '';
    if (typeof sectionObj === 'string') return sectionObj;

    const formatValue = (val, key) => {
      if (Array.isArray(val)) {
        if (val.length > 0 && typeof val[0] === 'object' && val[0] !== null) {
          return `
            <ul style="margin:0 0 0 18px;padding:0;">
              ${val.map(item => `<li>${formatSection(item)}</li>`).join('')}
            </ul>
          `;
        } else {
          return `
            <ul style="margin:0 0 0 18px;padding:0;">
              ${val.map(item => `<li>${item}</li>`).join('')}
            </ul>
          `;
        }
      } else if (typeof val === 'object' && val !== null) {
        // Special handling for Tailwinds: show each key-value as a bullet point
        if (key && key.toLowerCase() === 'tailwinds') {
          return `
            <ul style="margin:0 0 0 18px;padding:0;">
              ${Object.entries(val)
                .map(([k, v]) => `<li><b>${k.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}:</b> ${v}</li>`)
                .join('')}
            </ul>
          `;
        }
        return `<div style="margin-left:18px;">${formatSection(val)}</div>`;
      } else {
        return `${val}`;
      }
    };

    return `
      <div style="line-height:1.7;">
        ${Object.entries(sectionObj)
          .map(([key, val]) => {
            const label = key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
            const content = formatValue(val);

            if (Array.isArray(val) || typeof val === 'object') {
              return `<b>${label}:</b>${content}`;
            } else {
              return `<b>${label}:</b> ${content}<br/>`;
            }
          })
          .join('')}
      </div>
    `;
  };

  //#region change events
  const handleChange = (field, value) => {
    setCompanyDetails(prevDetails => ({
      ...prevDetails,
      [field]: value
    }));
  }

  //#region click events
  const onSaveClick = () => {
    updateCompanyDetails();
  }

  const onEditClick = () => {
    setIsSaveEnabled(true);
  }

  const onCancelClick = () => {
    if (aiGeneratedDetails?.companyOverviewText) {
      convertUpdatedDetails();
    } else {
      convertInitialTemplate();
    }
    setIsSaveEnabled(false);
  }

  //#region functions
  const convertUpdatedDetails = async () => {
    const requiredData = {
          basicDetails: {
            companyName: aiGeneratedDetails?.companyOverview?.name || '',
            founded: aiGeneratedDetails?.companyOverview?.founded || '',
            headquarters: aiGeneratedDetails?.companyOverview?.headquarters || '',
          },
          companyOverview: aiGeneratedDetails?.companyOverviewText,
          dealBackground: aiGeneratedDetails?.dealBackground || '',
          revenueModel: aiGeneratedDetails?.revenueModel || '',
          investmentSummary: aiGeneratedDetails?.investmentSummary || '',
          marketCompetition: aiGeneratedDetails?.marketAndCompetition || '',
          customers: aiGeneratedDetails?.customers || '',
    }
    setCompanyDetails(requiredData);
  }

  const convertInitialTemplate = async () => {
    
    const columns = aiGeneratedDetails?.Transaction?.AnnualTransactions?.Columns;
    const transactionColumns = columns && columns.length > 0 ? [
      {
        field: "Metric",
        headerName: columns[0],
        flex: 1,
        editable: false
      },
      ...columns.slice(1).map(col => ({
        field: col,
        headerName: col,
        flex: 1,
        editable: true
      }))
    ] : [];

    const rows = aiGeneratedDetails?.Transaction?.AnnualTransactions.Data?.map((row, idx) => ({
      id: idx + 1,
      ...row
    }));

    const formattedData = {
      basicDetails: {
        companyName: aiGeneratedDetails?.companyOverview?.name || '',
        founded: aiGeneratedDetails?.companyOverview?.founded || '',
        headquarters: aiGeneratedDetails?.companyOverview?.headquarters || '',
      },
      companyOverview: aiGeneratedDetails?.companyOverview ? formatSection(aiGeneratedDetails.companyOverview) : '',
      dealBackground: aiGeneratedDetails?.dealBackground ? formatSection(aiGeneratedDetails.dealBackground) : '',
      revenueModel: aiGeneratedDetails?.revenueModel ? formatSection(aiGeneratedDetails.revenueModel) : '',
      investmentSummary: aiGeneratedDetails?.investmentSummary ? formatSection(aiGeneratedDetails.investmentSummary) : '',
      marketCompetition: aiGeneratedDetails?.["marketAndCompetition"] 
      ? formatSection(aiGeneratedDetails["marketAndCompetition"])
      : aiGeneratedDetails?.marketAndCompetition
        ? formatSection(aiGeneratedDetails.marketAndCompetition)
        : '',
      /* transaction: rows,
      transactionColumns: transactionColumns, */
      customers: aiGeneratedDetails?.customers || '',
    };
    setCompanyDetails(formattedData);
  }

  //#Region api update calls
  const updateCompanyDetails = async () => {
    setLoading(true);
    const requiredData = JSON.parse(JSON.stringify(analysisDetails));
    requiredData.extAPIResponse.analysisResult.summary = {
      "dealBackground": companyDetails?.dealBackground || "",
      "companyOverview": analysisDetails?.extAPIResponse?.analysisResult?.summary?.companyOverview || "",
      "companyOverviewText": companyDetails?.companyOverview || "",
      "marketAndCompetition": companyDetails?.marketCompetition || "",
      "investmentSummary": companyDetails?.investmentSummary || "",
      "revenueModel": companyDetails?.revenueModel || "",
      "customers": companyDetails?.customers || "",
    }
    const data = await updateAnalysisDetails(analysisDetails?.docAnalysisID,requiredData?.extAPIResponse);
    if (data?.status === 200) {
      setLoading(false);
      toast.success(analysisToastMessages.UPDATE_SUCCESS,
        { position: "bottom-right", theme: "colored" }); 
      setIsSaveEnabled(false);
      fetchReportDetails();
    } else {
      setLoading(false);
      toast.warning(analysisToastMessages.UPDATE_FAILURE,
        { position: "bottom-right", theme: "colored" });
    }
  }

  //#region styles
  const styles = {
    colorBlue: {
      backgroundColor: "#1976d2",
      height: "2px",
      borderRadius: "1px",
    },
  };

  //#region useEffect
  useEffect(() => {
    if (aiGeneratedDetails) {
      if (aiGeneratedDetails?.companyOverviewText) {
        convertUpdatedDetails();
      } else {
        convertInitialTemplate();
      }
    }
  }, [aiGeneratedDetails]);

//#region return
  return (
    <div className='child-margin-15'>
      <div className='space-between'>
        <div></div>
        <div className='child-row-margin-10'>
          {
            isSaveEnabled
              ? <>
                <div>
                  <ActionButton
                    icon={<CancelIcon />}
                    variant={FieldVariants.OUTLINED}
                    label="cancel"
                    disabled={loading}
                    onClick={onCancelClick} />
                </div>
                <div>
                  <ActionButton
                    icon={<SaveIcon />}
                    variant={FieldVariants.CONTAINED}
                    label="Save"
                    loading={loading}
                    onClick={onSaveClick} />
                </div>
              </>
              : <div>
                <ActionButton
                  icon={<EditIcon />}
                  variant={FieldVariants.CONTAINED}
                  /* disabled={secureLocalStorage.getItem("userId") !== analysisDetails?.createdBy} */
                  label="EDIT"
                  onClick={onEditClick} />
              </div>
          }
          <div>
            <PdfTemplateDownload 
              isSaveEnabled={isSaveEnabled} 
              companyDetails={companyDetails}
              analysisDetails={analysisDetails} />
          </div>
          {/* <div>
            <ActionButton 
              icon={<ExitToAppIcon />} 
              variant={FieldVariants.OUTLINED} 
              label="Export to Word" 
              onClick={()=>{}}
              disabled={isSaveEnabled} />
          </div> */}
        </div>
      </div>
      {
        companyDetails
          ? <Grid container spacing={2}>
              <Grid item size={12}>
                <Grid container spacing={2}>
                  {
                    tiles?.map((tile) => (
                        <Grid item size={{ xs: 12, sm: 12 }}>
                        <div className="white-background space-between align-items-center">
                            <div className='child-margin-5'>
                              <div className='dashboard-card-title'>{tile.name}</div>
                              <b className='dashboard-card-value'>{tile.value}</b>
                            </div>
                            <div className='margin-top-10'>
                              {tile.icon}
                            </div>
                          </div>
                      </Grid>
                    ))
                  }
                </Grid>
              </Grid>
              <Grid item size={12}>
                <Box className='white-card'>
                  <Grid container spacing={2}>
                    <Grid item size={12} className='alt360-doc-banner height-90 align-items-center padding-10'>
                      <Grid item size={{ xs: 12, sm: 4 }} className='text-center'>
                        <h2 className='color-white'>ALT360</h2>
                      </Grid>
                      <Grid item size={{ xs: 12, sm: 4 }} className='text-center'>
                        <h2 className='color-white'>{companyDetails?.basicDetails?.companyName}</h2>
                      </Grid>
                      <Grid item size={{ xs: 12, sm: 4 }} className='text-center'>
                        <h2 className='color-white'>{companyDetails?.basicDetails?.founded}</h2>
                      </Grid>
                      <Grid item size={{ xs: 12, sm: 4 }} className='text-center'>
                        <h2 className='color-white'>{companyDetails?.basicDetails?.headquarters}</h2>
                      </Grid>
                    </Grid>
                    <Grid item size={{ xs: 12, sm: 6 }}>
                      {leftCompanyFields.map((field) => (
                        <div className='margin-top-10'>
                          <div
                            className={`child-row-margin-10 ${field?.size ? 'display-center' : ''}`}>
                            <b className="color-blue">{field.label}</b>
                          </div>
                          <Divider sx={styles.colorBlue} />
                          <div className='margin-top-10'>
                            <RichTextInput
                              name={field.name}
                              value={companyDetails[field.name]}
                              readOnly={!isSaveEnabled}
                              onChange={(name, value) => handleChange(name, value)} />
                          </div>
                        </div>
                      ))}
                    </Grid>
                    <Grid item  size={{ xs: 12, sm: 6 }}>
                      {rightCompanyFields.map((field) => (
                        <div className='margin-top-10'>
                          <div
                            className={`child-row-margin-10 ${field?.size ? 'display-center' : ''}`}>
                            <b className="color-blue">{field.label}</b>
                          </div>
                          <Divider sx={styles.colorBlue} />
                          <div className='margin-top-10'>
                            {
                              field.name === "transaction" 
                                ? <UDataGrid   
                                    name={field.name}
                                    height="auto"
                                    initialColumns={companyDetails["transactionColumns"]}
                                    readOnly={!isSaveEnabled}
                                    initialRows={companyDetails[field.name]}
                                    onRowChange={(name, value) => handleChange(name, value)}  /> 
                                : <RichTextInput
                                    name={field.name}
                                    value={companyDetails[field.name]}
                                    readOnly={!isSaveEnabled}
                                    onChange={(name, value) => handleChange(name, value)} />
                            }
                          </div>
                        </div>
                      ))}
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          : <LinearProgress />
      }
    </div>
  )
}

export default InvestmentConcept